(() => {
  'use strict';
  if (customElements.get('rc-comparison')) return;

  class RcComparison extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
    }
    init() {
      this.events?.abort();
      this.events = new AbortController();
      this.buttons = [...this.querySelectorAll('[data-product-chip]')];
      if (!this.buttons.length) return;
      this.classList.add('is-enhanced');
      const active = this.buttons.find(button => button.getAttribute('aria-pressed') === 'true') || this.buttons[0];
      this.select(active.dataset.productChip);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-product-chip]');
        if (button && this.contains(button)) this.select(button.dataset.productChip);
      }, {signal: this.events.signal});
    }
    select(id) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.productChip === id)));
      this.querySelectorAll('[data-product-column]').forEach(cell => {
        cell.classList.toggle('rc-column-selected', cell.dataset.productColumn === id);
      });
    }
  }
  customElements.define('rc-comparison', RcComparison);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('rc-comparison').forEach(element => element.init());
  });
})();
